import { product_categoryConstants } from '../_constants';

export function product_categories(state = {}, action) {
  switch (action.type) {
    case product_categoryConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case product_categoryConstants.GETALL_SUCCESS:
      return {
        items: action.categories.data
      };
    case product_categoryConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}


export function product_category(state = {}, action) {
  switch (action.type) {
    case product_categoryConstants.CURRENT_TOPIC:
      return {
        current_topic: action.id
      };
    case product_categoryConstants.REGISTER_SUCCESS:
      return {
        item: action.category.data
      };
    case product_categoryConstants.GET_REQUEST:
      return {
        loading: true
      };
    case product_categoryConstants.GET_SUCCESS:
      return {
        item: action.category.data
      };
    case product_categoryConstants.GET_FAILURE:
      return {
        error: action.error
      };
    case product_categoryConstants.DELETE_REQUEST:
      return {
        loading: true
      };
    case product_categoryConstants.DELETE_SUCCESS:
      return {
        loading: true
      };
    case product_categoryConstants.DELETE_FAILURE:
      return {
        loading: true
      };
    default:
      return state
  }
}
